export default __webpack_public_path__ + "static/media/12_3_0.f717c436.png";